import React, {Fragment, useCallback, useEffect, useState} from 'react';
import {
  Checkbox,
  Message,
  OverestimationModal,
  Pagination,
  ShowItemsSelectPageCount, ToFormRegisterModal,
  ToFormWithdrawalInventoryModal,
} from '../../utilites';
import {useDispatch, useSelector} from 'react-redux';
import {
  contractStatuses,
  pageOptions,
  viewDocument,
  viewReports
} from '../../../helpers/data-constants';
import {ActionButton, ConfirmModal } from '../../common';
import {permissionsAccess, returnEndStr, useQuery, validateDelayDays} from '../../../helpers/common';
import {
  changeContractStatuses,
  getDealsForTransfer,
  overestimationDeals,
  transferSaled,
  transferDeals, getClientContracts,
} from '../../../redux/actions/contractAction';
import {Link, useHistory} from 'react-router-dom';
import Loader from '../Loader/Loader';
import Arrow from '../../../assets/icons/arrow-down.svg';
import GarageDetails from './GarageDetails/GarageDetails';
import TransferSaledModal from '../../utilites/modal/TransferSaledModal/TransferSaledModal';
import moment from 'moment';
import GarageArchiveDetails from './GarageArchiveDetails/GarageArchiveDetails';

const initialState = {
  currentPage: 1,
  pageRange: pageOptions[0].value,
  isExpired: false,
  isOverestimation: false,
  isToGarage: false,
  isToTransferArchiveGarage: false,
  isTransferAnotherStore: false,
  isWithdrawal: false,
  viewDocument: '',
  isInventory: false,
};

const fields = [
  'amount',
  'basePercent',
  'cashBox',
  'cashBoxId',
  'clientFullName',
  'clientId',
  'couponId',
  'couponName',
  'dealNumber',
  'delayDays',
  'delayPercent',
  'endDate',
  'id',
  'positions',
  'additionalInformation',
  'carDate',
  'certificateDate',
  'certificateNumber',
  'comment',
  'estimatedValue',
  'marketPrice',
  'model',
  'names',
  'positionId',
  'quantity',
  'registrationNumber',
  'stateOFTheVehicle',
  'storageInCashBox',
  'vin',
  'refundAmount',
  'startDate',
  'status',
  'totalEstimatedValue',
  'totalToPay',
  'type',
  'waiverOfRedemption',
  'positions.positionId',
  'positions.names',
  'positions.quantity',
  'positions.estimatedValue',
  'graceDays'
]

const Garage = ({
                  dealStatus,
                  cashBoxInfo,
                  dataActiveCashbox,
                  setError,
                  stateSearch
}) => {
  const {cashBoxIds, fullName, dealNumber, typeDeal, delaysDay, typeDuration} = stateSearch;
  const dispatch = useDispatch();
  const {
    clientContracts: { deal, total },
    isLoading,
    commonError,
    modalError,
    isModalLoading,
    dealsForTransfer,
    changeContract,
  } = useSelector(({ contract }) => contract);
  const {accessFeatures} = useSelector(({user}) => user);

  const [garageContracts, setGarageContracts] = useState([])
  const [state, setState] = useState(initialState);
  const [selectedDeals, setSelectedDeals] = useState([]);
  const [allChecked, setAllChecked] = useState(false);

  const garage = dealStatus === contractStatuses.GARAGE.param;
  const archiveGarage = dealStatus === contractStatuses.GARAGE_ARCHIVE.param;
  const isExtensionThreeImplementaition = accessFeatures["extension.implementation.type.three"]

  const history = useHistory()
  const query = useQuery()
  const queryPageRange = query.get('pageRange')
  const queryPage = query.get('page')
  const queryStatus = query.get('dealStatus')

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      currentPage: 1,
    }))
  }, [cashBoxIds, dealNumber, typeDeal, fullName, delaysDay, typeDuration])

  useEffect(() => {
    setAllChecked(false);
    return () => {
      setState((prev) => ({
        ...prev,
        currentPage: 1,
        pageRange: pageOptions[0].value,
      }));
    };
  }, [dealStatus]);

  useEffect(() => {
    if(queryStatus === dealStatus) {
      let actualPageRange = state.pageRange;
      let actualPage = state.currentPage;

      if (!!queryPageRange) actualPageRange = +queryPageRange;
      if (!!queryPage) actualPage = +queryPage;
      setState((prev) => ({
        ...prev,
        currentPage: actualPage,
        pageRange: actualPageRange,
      }));
    }
  }, []);

  useEffect(() => {
    history.push({
      search: `?dealStatus=${dealStatus}&pageRange=${state.pageRange}&page=${state.currentPage}`
    })
  }, [dealStatus, state.pageRange, state.currentPage])

  useEffect(() => {
    const formattedDeals = deal.map((i) => {
      i.checked = false;
      i.isVisible = false;
      return i;
    });
    setGarageContracts(formattedDeals);
  }, [deal]);

  useEffect(() => {
    setSelectedDeals(garageContracts.filter((i) => i.checked));
  }, [garageContracts]);

  useEffect(() => {
    setAllChecked(false);
  }, [cashBoxIds]);

  useEffect(() => {
    const availableDepartaments = JSON.parse(localStorage.getItem('AVAILABLE_DEPARTMENTS'));
    const validationResult = validateDelayDays(delaysDay);

    if (validationResult) {
      setError(validationResult);
      return;
    } else {
      setError('')
    }

    const clientContracts = {
      size: state.pageRange,
      page: state.currentPage,
      status: dealStatus,
      id: 'all',
      descending: true,
      sortBy: isExtensionThreeImplementaition ? 'delayDays' : 'graceDays',
      dealType: 'car',
      cashBoxIds: permissionsAccess("expired.branch_director.search") && cashBoxIds.length === 0
          ? availableDepartaments.join(',')
          : cashBoxIds.map((i) => i.value).join(','),
      clientIds: fullName.map(i => i.value).join(','),
      dealDuration: typeDuration.map(i => i.value).join(','),
      dealIds: dealNumber.map(i => i.value).join(','),
      dealTypes: typeDeal.map(i => i.value).join(','),
      fields: fields,
      delayFrom: isExtensionThreeImplementaition ? delaysDay.from : undefined,
      delayTo: isExtensionThreeImplementaition ? delaysDay.to : undefined,
      graceFrom: isExtensionThreeImplementaition ? undefined : delaysDay.from,
      graceTo: isExtensionThreeImplementaition ? undefined : delaysDay.to
    };

    dispatch(getClientContracts(clientContracts));
  }, [
    state.pageRange,
    state.currentPage,
    dispatch,
    changeContract,
    dealStatus,
    cashBoxIds,
    fullName,
    dealNumber,
    typeDeal,
    fields,
    delaysDay,
    typeDuration
  ]);

  const onPageRangeChange = useCallback((value) => {
    setState((prev) => ({
      ...prev,
      pageRange: parseInt(value),
      currentPage: 1,
    }));
    setAllChecked(false);
  }, []);

  const handlePageChange = useCallback((page) => {
    setState((prev) => ({
      ...prev,
      currentPage: page,
    }));
    setAllChecked(false);
  }, []);

  const handleAllContractCheck = useCallback(() => {
    setGarageContracts((prev) => prev.map((item) => ({ ...item, checked: !allChecked })));
    setAllChecked(!allChecked);
  }, [allChecked]);

  const handleContractCheck = (contractId, isChecked) => {
     let contract = garageContracts.find((contract) => contract.id === contractId)
      if(contract) {
        contract.checked = isChecked;
      }
      setGarageContracts([...garageContracts]);
    }

  const returnToExpired = () => {
    if (selectedDeals.length) {
      if (garageContracts.length === selectedDeals.length && state.currentPage > 1) {
        setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
      }

      const dealIds = selectedDeals.map(({ id }) => id);
      dispatch(
        changeContractStatuses(
          dealIds,
          contractStatuses.ACTIVE.param,
          null,
          contractStatuses.GARAGE.param,
        ),
      );
      setAllChecked(false);
    }
  };

  const changeVisible = (id) => {
    let contract = garageContracts.find((contract) => contract.id === id)
    if(contract) {
      contract.isVisible = !contract.isVisible;
    }
    setGarageContracts([...garageContracts]);
  };

  const handleCloseModalWithdrawal = (view) => {
    setState((prev) => ({ ...prev, [view]: false, viewDocument: '' }));
  }

  const handleCloseModal = useCallback((view) => {
    setState((prev) => ({ ...prev, [view]: false, permissibleDate: null }));
  }, []);

  const openModal = useCallback(
    (view) => {
      if (selectedDeals.length) {
        if (view === viewDocument.isToTransferArchiveGarage || view === viewDocument.isOverestimation) {
          const dealIds = selectedDeals.map((deal) => deal.id).join(',')

          const payload = {
            size: 1000,
            page: 1,
            descending: false,
            filters: {
              status: dealStatus
            },
            orFilters: {
              dealIds
            },
            fields
          }
          dispatch(
            getDealsForTransfer(payload),
          );
        }

        if (view === viewDocument.isWithdrawal) {
          setState((prev) => ({
            ...prev,
            [view]: true,
            viewDocument: viewDocument.isWithdrawal,
            dealIds: selectedDeals.map((i) => i.id),
          }));
        }

        if (view === viewDocument.isInventory) {
          return setState((prev) => ({
            ...prev,
            [view]: true,
            dealIds: selectedDeals.map((i) => i.id),
            permissibleDate: selectedDeals.reduce(
              (p, c) => moment(p).min(c.transferDate).format('YYYY-MM-DD'),
              selectedDeals[0].transferDate,
            ),
          }));
        }

        setState((prev) => ({ ...prev, [view]: true }));
      }
    },
    [selectedDeals, dispatch, dealStatus],
  );

  const submitTransferArchiveGarage = useCallback((cash, deposit) => {
    handleCloseModal(viewDocument.isToTransferArchiveGarage);

    const dealIds = selectedDeals.map((deal) => deal.id);

    if (selectedDeals.length === garageContracts.length && state.currentPage > 1) {
      setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
    }

    const cashBoxId = dataActiveCashbox.current.value;

    const data = {
      dealIds,
      transferIds: undefined,
      status: dealStatus,
      data: undefined,
      cash,
      cashBoxId,
      deposit,
    }
    dispatch(transferSaled(data));

    setAllChecked(false);
  }, [dealStatus, dispatch, handleCloseModal, selectedDeals, garageContracts.length, state.currentPage]);

  const closeConfirm = useCallback(() => {
    archiveGarage && handleCloseModal(viewDocument.isToGarage);
  }, [handleCloseModal, garage]);

  const addToGarage = useCallback(() => {
    archiveGarage && handleCloseModal(viewDocument.isToGarage);

    const dealIds = selectedDeals.map((deal) => deal.id);

    if (selectedDeals.length === garageContracts.length && state.currentPage > 1) {
      setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
    }

    if (archiveGarage) {
      dispatch(
        changeContractStatuses(dealIds, contractStatuses.GARAGE.param, undefined, dealStatus),
      );
    }

    setAllChecked(false);
  }, [
    handleCloseModal,
    dispatch,
    selectedDeals,
    state.currentPage,
    garageContracts.length,
    dealStatus,
    archiveGarage,
  ]);

  const submitOverestimation = (data) => {
    let bodyReport = null;
    const reqBodyOverestimation = {
      dealsIds: data.dealsIds.map(({ dealId, estimatedValue }) => ({
        dealId,
        estimatedValue,
      })),
      base: data?.base ? data.base : '',
    };
    const markdownDeals = data.dealsIds.filter((i) => i.estimatedValue < i.totalEstimatedValue);

    if (markdownDeals.length) {
      const dealIds = markdownDeals.map(({ dealId }) => dealId).join(',');
      const filename =
        'exp_' +
        (data.documentNumber ? data.documentNumber : dealIds) +
        '_' +
        moment().format('DD.MM.YYYY') +
        '_.pdf';

      bodyReport = {
        reqBodyReport: {
          cashBoxId: cashBoxInfo.id,
          dealIds,
          documentNumber: data?.documentNumber ? data.documentNumber : 'б/н'
        },
        filename,
        viewReport: viewReports.MARKDOWN_ACT,
      };
    }

    if (selectedDeals.length === garageContracts.length && state.currentPage > 1) {
      setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
    }

    dispatch(overestimationDeals(reqBodyOverestimation, bodyReport));

    setAllChecked(false);
    handleCloseModal(viewDocument.isOverestimation);
  };

  const submitTransferAnotherStore = useCallback(
    (data) => {
      data.type = 'anothergarage';
      const dealIds = selectedDeals.map((deal) => deal.id)

      const filename = 'exp_' + data.documentNumber + '_' + data.transferDate + '.pdf';
      data.dealIds = dealIds;
      const viewReport = viewReports.MOVEMENT_GARAGE;

      if (selectedDeals.length === garageContracts.length && state.currentPage > 1) {
        setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
      }

      dispatch(transferDeals(data, viewReport, state.isTransferAnotherStore, { pdf: filename }));
      setAllChecked(false);
    },
    [dispatch, selectedDeals, garageContracts.length, state.currentPage, state.isTransferAnotherStore],
  );

  const submitTransferDeals = useCallback(
    (data, name = false, identity = false) => {

      const filename = 'exp_' + data.documentNumber + '_' + data.transferDate + '.pdf';
      let viewReport;

      if (garageContracts.length === state.dealIds.length && state.currentPage > 1) {
        setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
      }

      if (state.isWithdrawal) viewReport = viewReports.WITHDRAWAL;

      dispatch(transferDeals(data, viewReport, { pdf: filename }, name, identity));
      setAllChecked(false);
    },
    [
      dispatch,
      state.currentPage,
      garageContracts.length,
      state.dealIds,
      state.isWithdrawal,
    ],
  );

  const submitTransferInventory = (data) => {
    const filenamePdf = 'exp_' + data.documentNumber + '_' + data.transferDate + '.pdf';
    const filenameXlsx = 'exp_' + data.documentNumber + '_' + data.transferDate + '.xlsx';
    const viewReport = viewReports.INVENTORY_FROM_STORE;

    if (selectedDeals.length === garageContracts.length && state.currentPage > 1) {
      setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1, permissibleDate: null }));
    } else {
      setState((prev) => ({ ...prev, permissibleDate: null }));
    }

    dispatch(transferDeals(data, viewReport, { pdf: filenamePdf, xlsx: filenameXlsx }));
    setAllChecked(false);
  };

  return (
   <>
     {commonError && <Message type="error" text={commonError} />}
     <div className="content-datatable">
       <div className="content-datatable-header sticky">
         <div className="content-datatable-header-left buttongroup-content">
           <div className="action-items">
             {
               garage &&
                 <>
                   {
                     permissionsAccess("action.deal.status.transfer") &&
                     <ActionButton
                         text={'Вернуть в обработку'}
                         func={ returnToExpired }
                     />
                   }
                   {
                     permissionsAccess("action.deal.update.thing.estimated.value") &&
                     <ActionButton
                         text="Переоценка"
                         func={openModal}
                         param={viewDocument.isOverestimation}
                     />
                   }
                   {
                     permissionsAccess("action.deal.sale.garage") &&
                       <ActionButton
                      text="Отправить на продажу"
                      func={openModal}
                      param={viewDocument.isToTransferArchiveGarage}
                       />
                   }
                   { permissionsAccess("action.deal.transfer") &&
                       <>
                         <ActionButton
                             text="Передать в другой ломбард"
                             func={openModal}
                             param={viewDocument.isTransferAnotherStore}
                         />

                         <ActionButton
                             text="Сформировать изъятие"
                             func={openModal}
                             param={viewDocument.isWithdrawal}
                         />

                         <ActionButton
                             text="Сформировать инвентарь"
                             func={openModal}
                             param={viewDocument.isInventory}
                         />
                       </>
                   }
                 </>
             }
             {
               archiveGarage && permissionsAccess("action.deal.status.transfer.garage") &&
               <ActionButton
                     text='Вернуть в гараж'
                     func={openModal}
                     param={viewDocument.isToGarage}
                   />
             }
           </div>
         </div>
         <div className="content-datatable-header-right">
           <ShowItemsSelectPageCount
             options={pageOptions}
             change={onPageRangeChange}
             wrapClass={'padding-select'}
             statePageRange={state.pageRange}
           />
         </div>
       </div>
       <div className="content-datatable-content">
         {isLoading ? (
           <Loader pageRange={state.pageRange} />
         ) : (
           <table className="table hover">
             <thead>
             <tr>
               <th scope="col">
                 <Checkbox
                   label="Номер договора"
                   id="checkboxContractSelectAll"
                   name="checkboxContractSelectAll"
                   onChange={handleAllContractCheck}
                   value={allChecked}
                 />
               </th>
               <th scope="col">
                 <p>Клиент</p>
               </th>
               <th scope="col">
                 <p>Дней просрочки</p>
               </th>
               {!isExtensionThreeImplementaition && <th scope="col">
                 <p>Дней льготного срока</p>
               </th>}
               <th scope="col">
                 <p>Сумма на выкуп</p>
               </th>
               <th scope="col">
                 <p>Телефон</p>
               </th>
               <th scope="col"></th>
             </tr>
             </thead>
             <tbody>
             {garageContracts &&
             garageContracts.length !== 0 &&
             garageContracts.map((car) => {

               let delayDays = '';
               if (accessFeatures['deal.expired.total_to_pay_remind']) {
                const days = isExtensionThreeImplementaition ? car.delayDays : car.graceDays;
                 if (car.totalToPay >= car.totalEstimatedValue && days > 30) {
                   delayDays = 'overdue-delayColorGreen';
                 } else {
                   delayDays = 'overdue-delayColorRed';
                 }
               }
               const onChangeHandler = (e) => {
                 handleContractCheck(car.id, e.currentTarget.checked)
               }

               return (
                 <Fragment key={car.id}>
                   <tr>
                     <td>
                       <div className="table-cellcontent">
                         <Checkbox
                           id={car.id}
                           name={car.id}
                           onChange={ onChangeHandler }
                           value={car.checked}
                         />
                         <p>
                           <Link
                             className="table-link"
                             to={`client/${car.clientId}/contracts/${car.id}`}>
                             <span>{car.dealNumber || car.id}</span>
                           </Link>
                         </p>
                       </div>
                     </td>
                     <td>
                       <div className="table-celltrigger">
                         <p>{car.clientFullName && car.clientFullName}</p>
                       </div>
                     </td>
                     <td>
                       <p className={delayDays}>{returnEndStr(car.delayDays)}</p>
                     </td>
                     {!isExtensionThreeImplementaition && <td>
                       <p className={delayDays}>{returnEndStr(car.graceDays)}</p>
                     </td>}
                     <td>
                       <p>{car.totalToPay.toFixed(2)} руб.</p>
                     </td>
                     <td>
                       <p>
                         <a className="table-phone" href="tel:+375333516789">
                           <span>{car.clientPhone && car.clientPhone}</span>
                         </a>
                       </p>
                     </td>
                     <td
                       className={`overdueContentAll-table-col-arrow${
                         car.isVisible ? '-up' : ''
                       }`}>
                       <Arrow onClick={() => changeVisible(car.id)} />
                     </td>
                   </tr>
                   <tr
                     className={`overdueContentAll-table-line${ car.isVisible ? '-visible' : '' }`}>
                       { garage && <GarageDetails car={car} /> }
                       { archiveGarage && (
                         <td colSpan={"7"}>
                           <GarageArchiveDetails
                             car={car}
                           />
                         </td>
                         )
                       }
                   </tr>
                 </Fragment>
               );
             })}
             </tbody>
           </table>
         )}
       </div>
     </div>
     <Pagination
       total={Math.ceil(total / state.pageRange)}
       current={state.currentPage}
       handlePageChange={handlePageChange}
     />
     <OverestimationModal
       isOpen={state.isOverestimation}
       handleCloseModal={handleCloseModal}
       data={dealsForTransfer}
       submitOverestimation={submitOverestimation}
       modalError={modalError}
       isModalLoading={isModalLoading}
       view={state.isOverestimation}
       garage={true}
       tab={'GARAGE'}
     />
     <TransferSaledModal
       isOpen={state.isToTransferArchiveGarage}
       submitTransferSaledStore={submitTransferArchiveGarage}
       handleCloseModal={handleCloseModal}
       data={dealsForTransfer}
       modalError={modalError}
       isModalLoading={isModalLoading}
       viewDocument={viewDocument.isToTransferArchiveGarage}
       garage={true}
     />
     <ToFormRegisterModal
       printedFormButton = {false}
       isOpen={state.isTransferAnotherStore}
       handleCloseModal={handleCloseModal}
       cashBoxInfo={cashBoxInfo}
       submitTransferDeals={submitTransferAnotherStore}
     />
     <ConfirmModal
       isOpen={state.isToGarage}
       handleClose={closeConfirm}
       handleAction={addToGarage}
       headerText={'Вы хотите переместить в гараж?'}
     />
     { state.isWithdrawal &&
       <ToFormWithdrawalInventoryModal
         isOpen={state.isWithdrawal}
         handleCloseModal={handleCloseModalWithdrawal}
         view={state.viewDocument}
         cashBoxInfo={cashBoxInfo}
         dealIds={state.dealIds}
         submitTransferDeals={submitTransferDeals}
         permissibleDate={state.permissibleDate}
       />
     }
     { state.isInventory &&
       <ToFormWithdrawalInventoryModal
         isOpen={state.isInventory}
         handleCloseModal={handleCloseModal}
         view={viewDocument.isInventory}
         cashBoxInfo={cashBoxInfo}
         dealIds={state.dealIds}
         submitTransferDeals={submitTransferInventory}
         permissibleDate={state.permissibleDate}
       />
     }
   </>
  )
}

export default Garage
